import { useContext } from 'react';
import { ToastContext } from '../../providers/Toast.provider';
import './Toast.scss';
import { PiX } from 'react-icons/pi';

function Toast() {
    const { toasts, removeToast } = useContext(ToastContext);

    function getToasts() {
        return toasts.map((toast, index) => (
            <div className={`toast toast--${toast.type}`} key={index}>
                {toast.text}
                <button className="toast-close" onClick={() => removeToast(toast.id) }>
                    <PiX />
                </button>
            </div>
        ));
    }

    return (
        <div className="toast-container">
            {getToasts()}
        </div>
    );
}

export { Toast };
